<script setup lang="ts"></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="24" height="24" fill="url(#pattern0_5017_3)" />
    <defs>
      <pattern
        id="pattern0_5017_3"
        patternUnits="userSpaceOnUse"
        patternTransform="matrix(6.8 0 0 6.8 0 0)"
        preserveAspectRatio="none"
        viewBox="0 0 8 8"
        width="1"
        height="1"
      >
        <g id="pattern0_5017_3_inner">
          <circle cx="2" cy="2" r="2" fill="#FF0000" />
        </g>
      </pattern>
    </defs>
  </svg>
</template>
